"use client";

import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { auswahlCls } from "../../lib/styles";
import { AUTHENTICATOR_APPS } from "./zweitfaktor-apps";

/**
 * „Welche App, und wo tippe ich?" — aufklappbar unter dem QR-Code.
 *
 * Zugeklappt, weil wer die App schon hat, sie nicht braucht; offen steht dann EINE App mit
 * drei nummerierten Schritten. Die Wahl ist ein Knopf je App statt einer Auswahlliste:
 * die Namen sind das, was man wiedererkennt, und am Handy ist ein Knopf leichter zu treffen.
 */
export function ZweitfaktorAnleitung() {
  const [offen, setOffen] = useState(false);
  const [appId, setAppId] = useState(AUTHENTICATOR_APPS[0].id);
  const app = AUTHENTICATOR_APPS.find((a) => a.id === appId) ?? AUTHENTICATOR_APPS[0];

  return (
    <div className="rounded-[var(--radius)] border border-border">
      <button
        type="button"
        onClick={() => setOffen((o) => !o)}
        aria-expanded={offen}
        aria-controls="zf-anleitung"
        className="flex w-full items-center justify-between gap-3 px-3 py-2.5 text-left text-xs font-medium"
      >
        <span>Noch keine App, oder unsicher? Schritt für Schritt</span>
        <ChevronDown size={14} className={`shrink-0 transition-transform ${offen ? "rotate-180" : ""}`} aria-hidden />
      </button>

      {offen && (
        <div id="zf-anleitung" className="space-y-3 border-t border-border px-3 py-3">
          <p className="text-[11px] text-muted-foreground">
            Jede dieser Apps funktioniert. Hast du schon einen Passwortmanager, nimm ihn — dann liegt
            alles an einer Stelle.
          </p>
          <div className="flex flex-wrap gap-1.5" role="group" aria-label="App auswählen">
            {AUTHENTICATOR_APPS.map((a) => (
              <button
                key={a.id}
                type="button"
                onClick={() => setAppId(a.id)}
                aria-pressed={a.id === app.id}
                className={`px-2.5 py-1 text-[11px] ${auswahlCls(a.id === app.id)}`}
              >
                {a.name}
              </button>
            ))}
          </div>
          <div className="space-y-2">
            <div className="text-[11px] text-muted-foreground">{app.hinweis}</div>
            <ol className="space-y-2">
              {app.schritte.map((schritt, i) => (
                <li key={i} className="flex gap-2.5 text-xs">
                  <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full border border-border text-[10px] font-medium tabular-nums">
                    {i + 1}
                  </span>
                  <span className="pt-0.5 leading-relaxed">{schritt}</span>
                </li>
              ))}
            </ol>
          </div>
        </div>
      )}
    </div>
  );
}
